<template>
  <div>
    <b-row class="mb-1">
      <b-col v-if="$can('AddClientPrivileges', 'ClientPrivileges')">
        <b-button v-b-modal.modal-addPrevilage variant="primary">
          <span class="text-nowrap">Add New</span>
        </b-button>
      </b-col>
    </b-row>
    <b-card title="Privilages">
      <!-- search input -->
      <b-row>
        <b-col>
          <div class="custom-search d-flex justify-content-start">
            <b-form-group>
              <b-form-input
                v-model="searchTerm"
                placeholder="Search"
                type="text"
                class="d-inline-block mr-1"
              />
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="previlages"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <!-- Column: Action  -->
        <!-- <template slot="table-row" slot-scope="props">
           
          <span v-if="props.column.field === 'edit'">
            <b-button
              v-if="$can('Update', 'Role')"
              href="#"
              variant="warning"
              @click="editprevilageModal(props.row.id)"
            >
              <feather-icon icon="EditIcon" class="mr-50" />
              Edit
            </b-button>
          </span>
        </template> -->
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <!-- Edit previlage -->
      <b-col>
        <b-modal
          id="modal-editPrevilage"
          ref="modal"
          hide-footer
          title="Edit Previlage"
          size="lg"
        >
          <validation-observer ref="simpleRules">
            <form ref="form">
              <b-row>
                <b-col md="6">
                  <b-form-group label="Action" label-for="action">
                    <validation-provider
                      #default="{ errors }"
                      name="action"
                      rules="required"
                    >
                      <b-form-input
                        v-on:keypress="isLetter($event)"
                        id="action-input"
                        v-model="editprevilage.action"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Module" label-for="module">
                    <validation-provider
                      #default="{ errors }"
                      name="module"
                      rules="required"
                    >
                      <b-form-input
                        v-on:keypress="isLetter($event)"
                        id="module-input"
                        v-model="editprevilage.module"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Description" label-for="description">
                    <validation-provider
                      #default="{ errors }"
                      name="description"
                    >
                      <b-form-input
                        v-on:keypress="isLetter($event)"
                        id="description-input"
                        v-model="editprevilage.description"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button
                variant="primary"
                type="submit"
                @click.prevent="submitEditPrevilage"
              >
                Save
              </b-button>
            </form>
          </validation-observer>
        </b-modal>
      </b-col>

      <!-- Add Previlage -->
      <b-col>
        <b-modal
          id="modal-addPrevilage"
          ref="modal"
          hide-footer
          title="Add Previlage"
          size="lg"
        >
          <validation-observer ref="simpleRules">
            <form ref="form">
              <b-row>
                <b-col md="6">
                  <b-form-group label="Action" label-for="action">
                    <validation-provider
                      #default="{ errors }"
                      name="action"
                      rules="required"
                    >
                      <b-form-input
                        v-on:keypress="isLetter($event)"
                        v-on:paste="
                          (e) => {
                            e.preventDefault();
                            return false;
                          }
                        "
                        id="action-input"
                        v-model="addprevilage.action"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Module" label-for="module">
                    <validation-provider
                      #default="{ errors }"
                      name="module"
                      rules="required"
                    >
                      <b-form-input
                        v-on:keypress="isLetter($event)"
                        v-on:paste="
                          (e) => {
                            e.preventDefault();
                            return false;
                          }
                        "
                        id="module-input"
                        v-model="addprevilage.module"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Description" label-for="description">
                    <validation-provider
                      #default="{ errors }"
                      name="description"
                    >
                      <b-form-input
                        v-on:keypress="isLetter($event)"
                        v-on:paste="
                          (e) => {
                            e.preventDefault();
                            return false;
                          }
                        "
                        id="description-input"
                        v-model="addprevilage.description"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button
                variant="primary"
                type="submit"
                @click.prevent="submitAddPrevilage"
              >
                Save
              </b-button>
            </form>
          </validation-observer>
        </b-modal>
      </b-col>

      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BAvatar,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store";
import { required } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "@axios";
import useJwt from "@/auth/jwt/useJwt";

export default {
  name: "Roles",
  components: {
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,

    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      isLoading: false,
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      activeRow: null,
      columns: [
        {
          label: "Action",
          field: "action",
        },
        {
          label: "Module",
          field: "module",
        },
        {
          label: "Description",
          field: "description",
        },
        {
          label: "",
          field: "edit",
        },
      ],
      previlages: [],
      addprevilage: {
        action: "",
        module: "",
        description: "",
      },

      searchTerm: "",
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    accessTypeVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-info",
        2: "light-primary",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s-]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    fetchData() {
      this.$store.dispatch(
        "config/getActionPrivilege",
        "ClientPrivileges-GetAll",
      );
      this.isLoading = true;
      axios
        .get("/api/DatabaseSeeding/GetAllClientPrivileges")
        .then((res) => {
          this.isLoading = false;
          this.previlages = res;
        })
        .catch(() => {
          this.isLoading = false;
        });
      this.isLoading = true;
      axios
        .get("/api/V1.0/ClientAccount/GetAll")
        .then((res) => {
          this.isLoading = false;
          this.addprevilage.clientUserId = res.clientUsers.filter(
            (i) => i.username == "PortalAdmin@ethiopianairlines.com",
          )[0].id;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    editprevilageModal(id) {
      const previlage = this.previlages.filter((i) => i.id === id);
      previlage[0].clientUserId = this.addprevilage.clientUserId;
      this.editprevilage = previlage[0];
      console.log(this.editprevilage);
      this.$bvModal.show("modal-editPrevilage");
    },
    submitEditPrevilage() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.$bvModal.hide("modal-editPrevilage");
          this.isLoading = true;
          axios
            .post("/User/api/V1.0/Privilege/Update", this.editprevilage)
            .then((res) => {
              this.isLoading = false;
              this.$bvModal
                .msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then((result) => {
                  this.fetchData();
                });
            })
            .catch((res) => {
              console.log(res);
              this.isLoading = false;
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
    submitAddPrevilage() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.isLoading = true;
          axios
            .post(
              "/ClientUser/api/V1.0/ClientPrivilege/Save",
              this.addprevilage,
            )
            .then((res) => {
              this.$bvModal.hide("modal-addPrevilage");
              this.isLoading = false;
              this.$bvModal
                .msgBoxOk(`Record Added`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then((result) => {
                  if (result) {
                    this.addprevilage.action = "";
                    this.addprevilage.module = "";
                    this.addprevilage.description = "";
                    this.fetchData();
                  }
                });
            })
            .catch((res) => {
              console.log(res);
              this.isLoading = false;
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
